<template>
  <div class="main main--contentful">
    <ui-article-sidebar />

    <div class="group--sticky-sidebar">
      <ui-search v-if="showSearch" />

      <router-view />

      <transition name="fade" mode="out-in">
        <ui-module-loader
          key="loader"
          v-if="loading"
          :messages="['Please give us a moment load your content']"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// Modules
import UiArticleSidebar from 'components/ArticleSidebar';
import UiSearch from 'components/Search';
import UiModuleLoader from 'components/ModuleLoader';

export default {
  name: 'view-contentful',

  // Components
  components: {
    UiArticleSidebar,
    UiSearch,
    UiModuleLoader,
  },

  // Computed
  computed: {
    ...mapGetters('contentful', ['loading']),

    showSearch() {
      const routesToShow = [
        'topics',
        'search-results',
      ];

      return routesToShow.indexOf(this.$route.name) !== -1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Contentful.vue?25bb9565